import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import '../assets/styles/Disclaimer.css';

function Disclaimer() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Disclaimer</title>
        <meta name="description" content="Read RFF Cargo’s disclaimer regarding our logistics services, website usage, and limitations of liability." />
      </Helmet>
      <section className="disclaimer-section py-5">
        <div className="container">
          <h2 className="disclaimer-title fw-bold mb-4">Disclaimer</h2>
          <p className="disclaimer-description">
            The information provided on the RFF Cargo website is for general informational purposes only and does not constitute professional, legal, or financial advice. While we strive to ensure the accuracy and timeliness of the content, RFF Cargo makes no warranties or representations regarding the completeness, reliability, or suitability of the information provided.
          </p>
          <div className="disclaimer-content mt-4">
            <h3 className="disclaimer-subtitle h5 mb-3">General Information</h3>
            <p className="disclaimer-text">
              The content on this website, including but not limited to text, graphics, images, and other materials, is intended to provide an overview of RFF Cargo’s logistics and freight services. It is not a substitute for professional advice or specific contractual agreements. Users should consult with qualified professionals or contact RFF Cargo directly for tailored solutions regarding transportation, logistics, or supply chain management.
            </p>
            <h3 className="disclaimer-subtitle h5 mb-3">Limitation of Liability</h3>
            <p className="disclaimer-text">
              RFF Cargo, its affiliates, employees, or agents shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from the use of, or inability to use, this website or its content. This includes, but is not limited to, errors, omissions, or delays in the information provided. Users access and use the website at their own risk.
            </p>
            <h3 className="disclaimer-subtitle h5 mb-3">Third-Party Links</h3>
            <p className="disclaimer-text">
              This website may contain links to third-party websites for convenience or reference. RFF Cargo does not endorse or control these external sites and is not responsible for their content, accuracy, or practices. Accessing third-party websites is at the user’s own risk, and we recommend reviewing their respective terms and privacy policies.
            </p>
            <h3 className="disclaimer-subtitle h5 mb-3">Service Availability</h3>
            <p className="disclaimer-text">
              While RFF Cargo aims to provide accurate information about our services, including ocean freight, air freight, cargo express, and logistics solutions, availability may vary by region or be subject to change without notice. For the most current information, please contact our offices in India or Dubai.
            </p>
            <h3 className="disclaimer-subtitle h5 mb-3">Changes to Terms</h3>
            <p className="disclaimer-text">
              RFF Cargo reserves the right to modify, update, or remove any part of this disclaimer or website content at any time without prior notice. Users are encouraged to review this page periodically for updates. Continued use of the website constitutes acceptance of any changes.
            </p>
            <p className="disclaimer-text mt-4">
              For questions or clarification regarding this disclaimer, please reach out to us.
            </p>
            <Link to="/contact" className="btn btn-learn-more mt-3">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Disclaimer;